import { API_URL_HACKATAO_LEARN_MORE } from "@constants/Clients/hackatao/hackatao.env";
import apiInstance from "@services/Shared/instanceAxios";

const getLearnMore = () =>
  apiInstance({
    url: API_URL_HACKATAO_LEARN_MORE,
    params: {
      order: "desc",
      sort: "createdAt",
    },
  });

export default getLearnMore;
